import Compressor from "compressorjs";
import { Area } from "react-easy-crop";

/**
 *
 * @param file
 * @param finalMaxFileSize // in octets:  10mb = 10 * 1000 * 1000; 200ko = 200 * 1000
 * @returns
 */
export const tryCompressImage = async (file: File, finalMaxFileSize: number): Promise<Blob> => {
  let quality = 0.9; // Initial quality
  let maxWidth = 1000; // Max width
  let maxHeight = 1000; // Max height

  // First compression attempt
  let compressedFile = await compressImage(file, quality, maxWidth, maxHeight);

  // If the image is still larger than 200 KB, adjust settings and try again
  console.log(compressedFile.size / 1000, finalMaxFileSize / 1000, quality);
  while (compressedFile.size > finalMaxFileSize && quality > 0.1) {
    console.log(compressedFile.size / 1000, finalMaxFileSize / 1000, quality);
    quality -= 0.1; // Decrease quality
    maxWidth = Math.max(600, maxWidth * 0.9); // Reduce width by 10%
    maxHeight = Math.max(600, maxHeight * 0.9); // Reduce height by 10%
    compressedFile = await compressImage(file, quality, maxWidth, maxHeight);
  }

  // If the file is still larger than 200 KB after several attempts, alert the user
  console.log("compressedFile.size", compressedFile.size);
  if (compressedFile.size > finalMaxFileSize) {
    throw new Error("Image is too large even after compression.");
  }

  return compressedFile;
};

export const compressImage = (file: File, quality: number, maxWidth: number, maxHeight: number): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality,
      maxWidth,
      maxHeight,
      success(result: Blob) {
        resolve(result);
      },
      error(err: Error) {
        reject(err);
      },
    });
  });
};

export const getCroppedImg = (imageSrc: string, pixelCrop: Area): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    // Only set crossOrigin if it's not a local blob/data URL to avoid unnecessary preflight or secondary issues
    if (imageSrc.startsWith("http")) {
      image.crossOrigin = "anonymous";
    }

    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Could not get canvas context"));
        return;
      }

      const { x, y, width, height } = pixelCrop;
      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(image, x, y, width, height, 0, 0, width, height);

      // resolve(canvas.toDataURL("image/jpeg"));
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Canvas toBlob failed"));
          }
        },
        "image/jpeg",
        1
      );
    };

    image.onerror = () => {
      const shortSrc = imageSrc.substring(0, 30);
      reject(new Error(`Failed to load image: ${shortSrc}...`));
    };

    // Set src AFTER handlers are attached to avoid race conditions (especially with cached images)
    image.src = imageSrc;
  });
};
